import { View } from '../../../../components/discover/aivy-pdf-reports/compiler'
import AtAGlance from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/AtAGlance'
import MatchingDimensionCard from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/MatchingDimensionCard'
import OurReview from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/OurReview'
import RiasecInsights from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/RiasecInsights'
import { useTranslationContext } from '../../../../components/discover/aivy-pdf-reports/context/general-translations'

export default function InterestsDetailsMessage({
  interestsCategory,
  overall_insights,
  score_visible,
  our_review_title,
  riasec,
  insights_labels,
  language
}) {
  const { tGeneral } = useTranslationContext()
  return (
    <div>
      <View>
        <View>
          <AtAGlance
            title={interestsCategory.name[language]}
            description={tGeneral('interests_description')}
            score={overall_insights.insights.interests.group_match}
            score_visible={score_visible}
          />
          <View style={{ marginTop: 16 }}>
            <OurReview
              title={our_review_title}
              description={`${overall_insights.insights.interests.category_fit} ${overall_insights.insights.interests.evaluation_level}`}
              score={overall_insights.insights.interests.group_match}
            />
          </View>
        </View>

        <RiasecInsights
          {...{ ...riasec.riasec_insights, language }}
          containerStyle={{ marginTop: 16 }}
          renderedInDetailsMessage={true}
        />

        <View style={{ marginTop: 16 }}>
          <MatchingDimensionCard
            {...{
              ...riasec.riasec_images_elevation,
              insights_labels,
              language
            }}
          />
        </View>
      </View>
    </div>
  )
}
